module.exports = __webpack_public_path__ + "static/media/logo-ministop@3x.66851653.png";